/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Clearfix,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { Link, withRouter } from "react-router-dom";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { loginuser } from "../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import { setCustomUserID } from "../../utils/Clarity.js";

import logo from "assets/img/logo-white.png";
class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      email: "",
      password: "",
      _notificationSystem: null,
      /// Login
      emailLogin: "",
      emailErrorLogin: null,
      passwordLogin: "",
      passwordErrorLogin: null,
      userinfo: "",
      role: "",
    };
    this.handleClick = this.handleClick.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
  }
  componentDidMount() {
    if (localStorage.getItem("user")) {
      window.location.href = "/admin/dashboard";
      const userDetails = localStorage.getItem("user");
    } else {
      this.setState({ _notificationSystem: this.refs.notificationSystem });
      setTimeout(
        function () {
          this.setState({ cardHidden: false });
        }.bind(this),
        700
      );
    }
  }
  handlesubmit() {
    this.handleClick("tl");
    loginuser(this.state.email, this.state.password).then((data) => {
      var cus_data = data.data;
      setTimeout(() => {
        setCustomUserID(cus_data, cus_data.id);
      }, 1000);
      localStorage.setItem("user", JSON.stringify(data.data));
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Login failed</b> - Please check credentials.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Login Successfully</b> - Please wait we are redirecting.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleLoginEmail(event) {
    this.setState({
      emailLogin: event.target.value,
    });
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailErrorLogin: (
            <small className="text-danger">
              Email is required and format should be <i>john@doe.com</i>.
            </small>
          ),
        })
      : this.setState({ emailErrorLogin: null });
  }
  handleLoginPassword(event) {
    this.setState({
      passwordLogin: event.target.value,
    });
    event.target.value.length < 6
      ? this.setState({
          passwordErrorLogin: (
            <small className="text-danger">
              You must enter a password of at least 6 characters.
            </small>
          ),
        })
      : this.setState({ passwordErrorLogin: null });
  }
  handleLoginSubmit() {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let error = false;
    if (re.test(this.state.emailLogin) === false) {
      error = true;
      this.setState({
        emailErrorLogin: (
          <small className="text-danger">
            Email is required and format should be <i>john@doe.com</i>.
          </small>
        ),
      });
    } else {
      this.setState({ emailErrorLogin: null });
    }

    if (this.state.passwordLogin < 6) {
      error = true;
      this.setState({
        passwordErrorLogin: (
          <small className="text-danger">
            You must enter a password of at least 6 characters.
          </small>
        ),
      });
    } else {
      this.setState({ passwordErrorLogin: null });
    }

    if (!error) {
      loginuser(this.state.emailLogin, this.state.passwordLogin).then(
        (data) => {
          if (data.success == true) {
            var cus_data = data.data;
            this.setState({ role: cus_data.role });
            setCustomUserID(cus_data, cus_data.id);
            this.handleSuccess("bl");
            localStorage.setItem("user", JSON.stringify(data.data));
            setTimeout(
              () =>
                this.state.role == 18
                  ? this.props.history.push("/admin/order_list")
                  : this.props.history.push("/admin/dashboard"),
              1000
            );
            this.setState({
              userinfo: "User Authenticated",
            });
          } else {
            this.setState({
              userinfo: "User Not Authenticated",
            });
            this.handleClick("bl");
          }
        }
      );
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  render() {
    return (
      <div>
        <Grid>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img src={logo} alt="react-logo" width="200" />
          </div>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={4} sm={6} mdOffset={4} smOffset={3}>
              <form>
                <Card
                  textCenter
                  title="Login Form"
                  content={
                    <div>
                      <FormGroup>
                        <ControlLabel>
                          Email : <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="text"
                          name="email"
                          onChange={(event) => this.handleLoginEmail(event)}
                        />
                        {this.state.emailErrorLogin}
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>
                          Password: <span className="star">*</span>
                        </ControlLabel>
                        <FormControl
                          type="password"
                          name="password"
                          autoComplete="off"
                          onChange={(event) => this.handleLoginPassword(event)}
                        />
                        {this.state.passwordErrorLogin}
                      </FormGroup>
                      <div className="category">
                        <span className="star">*</span> Required fields
                      </div>
                      <div className="category" style={{ paddingTop: "20px" }}>
                        <span className="star">
                          <Link to="/auth/forgot-password-page">
                            Forgot Password ?
                          </Link>
                        </span>
                      </div>
                      <br></br>
                      <div>
                        {this.state.userinfo.length > 0 ? (
                          <p>
                            {" "}
                            {this.state.userinfo == "User Not Authenticated" ? (
                              <div className="category ">
                                {this.state.userinfo}{" "}
                                <i
                                  style={{ color: "red" }}
                                  className="fa fa-times"
                                >
                                  {" "}
                                </i>{" "}
                              </div>
                            ) : (
                              <div className="category">
                                {this.state.userinfo}
                                <i
                                  style={{ color: "green" }}
                                  className="fa fa-check"
                                >
                                  {" "}
                                </i>{" "}
                              </div>
                            )}{" "}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  }
                  ftTextCenter
                  legend={
                    <Button
                      bsStyle="default"
                      fill
                      wd
                      onClick={this.handleLoginSubmit.bind(this)}
                    >
                      Login
                    </Button>
                  }
                />
              </form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default LoginPage;
